import {Device, DeviceOsd, DeviceStatus, DockOsd, GatewayOsd} from "@/types/device";
import {WaylineFile} from "@/types/wayline";
import {DevicesCmdExecuteInfo} from "@/types/device-cmd";
import {defineStore} from "pinia";
import {DeviceTypeName} from "@/types/enum";

export interface DeviceHms {
}

const initStateFunc = () => ({
  eagleEyeMap:{
    visible:false
  },
  isFullShow: false,
  livestreamSource: [],
  vehicleLiveList: [],
  myInterval: null,
  selectSn: '',
  cesiumViewer: null,
  Layers: [
    {
      name: 'default',
      id: '',
      is_distributed: true,
      elements: [],
      is_check: false,
      is_select: false,
      type: 1
    },
    {
      name: 'share',
      id: '',
      is_distributed: true,
      elements: [],
      is_check: false,
      is_select: false,
      type: 2
    }
  ],
  layerBaseInfo: {} as {
    [key:string]:string
  },
  drawVisible: false,
  coverList: [

  ] as any,
  wsEvent: {
    mapElementCreat: {},
    mapElementUpdate: {},
    mapElementDelete: {}
  },
  deviceStatusEvent: {
    deviceOnline: {} as DeviceStatus,
    deviceOffline: {}
  },
  markerInfo: {
    coverMap: {} as {
      [sn: string]: any
    },
    pathMap: {} as {
      [sn: string]: any[]
    }
  },
  deviceState: {
    // remote controller, dock
    gatewayInfo: {} as {
      [sn: string]: GatewayOsd
    },
    // drone
    deviceInfo: {} as {
      [sn: string]: DeviceOsd
    },
    dockInfo: {} as {
      [sn: string]: DockOsd
    },
    currentSn: '',
    currentType: -1
  },

  osdVisible: {
    sn: '',
    callsign: '',
    model: '',
    visible: false,
    gateway_sn: '',
    gateway_callsign:'',
    is_dock: false,
    payloads: null,
    dockControlPanelVisible: false
  },

  waylineInfo: {

  } as WaylineFile,
  dockInfo: {

  } as Device,
  hmsInfo: {} as {
    [sn: string]: DeviceHms[]
  },
  // 机场指令执行状态信息
  devicesCmdExecuteInfo: {
  } as DevicesCmdExecuteInfo,
  mqttState: null as any, // mqtt 实例
  clientId: '', // mqtt 连接 唯一客户端id

})

export type RootStateType = ReturnType<typeof initStateFunc>

// export const storeKey: InjectionKey<Store<RootStateType>> = Symbol('')

type AllStateStoreTypes = RootStateType & {
  // moduleName: moduleType
}

export const useMyStore = defineStore('MyStore',{
  state: initStateFunc,
  getters: {
    getEagleEyeMap:(state) => state.eagleEyeMap,
    getVehicleLiveList: (state) => state.vehicleLiveList,
    getDockInfo: (state) => state.deviceState.dockInfo,
    getDeviceStatus: (state) => state.deviceState.deviceInfo,
    getGatewayInfoStatus: (state) => state.deviceState.gatewayInfo,
    getOsdVisible: (state) => state.osdVisible,
    getHmsInfo: (state) => state.hmsInfo,
    getDeviceStatusBySn: (state) => (sn: string) => state.deviceState.deviceInfo[sn],
    getDeviceCmdExecuteInfo:(state) => state.devicesCmdExecuteInfo,
    getDeviceStatusBySnAndType: (state) => (sn: string, type: number) => {
      if (type === 1) {
        return state.deviceState.deviceInfo[sn]
      }
    },

  },
  actions: {
    async SetDockInfo(info:any){
      if (Object.keys(info.host).length === 0) {
        return
      }
      if (!this.$state.deviceState.dockInfo[info.sn]) {
        this.$state.deviceState.dockInfo[info.sn] = { } as DockOsd
      }
      this.$state.deviceState.currentSn = info.sn
      this.$state.deviceState.currentType = DeviceTypeName.Dock
      const dock = this.$state.deviceState.dockInfo[info.sn]
      if (info.host.mode_code !== undefined) {
        dock.basicOsd = info.host
        return
      }
      if (info.host.sdr) {
        dock.linkOsd = info.host
        return
      }
      if (info.host.job_number !== undefined) {
        dock.workOsd = info.host
      }
    },
    async SetGatewayInfo(info:any){
      // console.log(info)
      this.$state.deviceState.gatewayInfo[info.sn] = info.host
      this.$state.deviceState.currentSn = info.sn
      this.$state.deviceState.currentType = DeviceTypeName.Gateway
    },
    async SetDeviceInfo(info:any){
      this.$state.deviceState.deviceInfo[info.sn] = info.host
      this.$state.deviceState.currentSn = info.sn
      this.$state.deviceState.currentType = DeviceTypeName.Aircraft
    },
    async SetDeviceOnline(info:any){
      this.$state.deviceStatusEvent.deviceOnline = info
    },
    async SetDeviceOffline(info:any){
      this.$state.deviceStatusEvent.deviceOffline = info
      delete this.$state.deviceState.gatewayInfo[info.sn]
      delete this.$state.deviceState.deviceInfo[info.sn]
      delete this.$state.deviceState.dockInfo[info.sn]
      delete this.$state.hmsInfo[info.sn]
    },
    async SetDeviceHmsInfo(info:any){
      const hmsList: Array<DeviceHms> = this.$state.hmsInfo[info.sn]
      this.$state.hmsInfo[info.sn] = info.host.concat(hmsList ?? [])
    },
    async SetDeviceCmdExecuteInfo(info:any){
      console.log(info)
      if (!info.sn) {
        return
      }
      if (this.$state.devicesCmdExecuteInfo[info.sn]) {
        const index = this.$state.devicesCmdExecuteInfo[info.sn].findIndex(cmdExecuteInfo => cmdExecuteInfo.biz_code === info.biz_code)
        if (index >= 0) {
          // 丢弃前面的消息
          if (this.$state.devicesCmdExecuteInfo[info.sn][index].timestamp > info.timestamp) {
            return
          }
          this.$state.devicesCmdExecuteInfo[info.sn][index] = info
        } else {
          this.$state.devicesCmdExecuteInfo[info.sn].push(info)
        }
      } else {
        this.$state.devicesCmdExecuteInfo[info.sn] = [info]
      }
    },

    async setMqttState(info:any){
      this.$state.mqttState = info
    },
    async setClientId(info:any){
      this.$state.clientId = info
    },
  }
})

